export default "__VITE_ASSET__Lsk57Qbt__"